import { render } from "./TaskList.vue?vue&type=template&id=74319361&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=74319361&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74319361"

export default script